import React from "react";

import { LoginStackNavigator } from "./navigation";

import { LoginScreen } from "./LoginScreen";
import { GroupDeviceLoginScreen } from "@/src/features/GroupDevice/GroupDeviceLogin";
import { useNavigationHeaderOptions } from "@/src/common/navigationHeaderOptions";
import { SupportAccessEntry } from "@/src/features/SupportAccess/SupportAccessEntry";

export const Login = () => {
  const getOptions = useNavigationHeaderOptions();
  return (
    <LoginStackNavigator.Navigator
      screenOptions={{
        presentation: "modal",
      }}
    >
      <LoginStackNavigator.Screen
        options={{ headerShown: false }}
        name="Login"
        component={LoginScreen}
      />
      <LoginStackNavigator.Screen
        options={({ navigation }) =>
          getOptions({
            type: "CLOSE",
            title: "",
            onClose: () => {
              navigation.goBack();
            },
          })
        }
        name="GroupDeviceLogin"
        component={GroupDeviceLoginScreen}
      />
      <LoginStackNavigator.Screen
        name="SupportAccessEntry"
        component={SupportAccessEntry}
        options={{
          headerShown: false,
        }}
      />
    </LoginStackNavigator.Navigator>
  );
};
